import { useStoreValue } from '@/lib/react-hooks/generic-hooks'

export function useIsLoggedIn() {
	const user = useStoreValue(({ auth }) => auth.get('user'))
	const internalUser = useStoreValue(({ auth }) => auth.get('internalUser'))

	return !!user && !!internalUser
}
